module.exports = __webpack_public_path__ + "static/img/icon05.15828824.svg";